import { Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { STATUS_COLORS } from "@/lib/canvas-utils";

interface StatusFilterDropdownProps {
  selectedStatuses: Set<string>;
  onStatusToggle: (status: string) => void;
}

const STATUS_LABELS = {
  open: "Open",
  inProgress: "In Progress",
  resolved: "Resolved",
  skipped: "Skipped",
};

export function StatusFilterDropdown({
  selectedStatuses,
  onStatusToggle,
}: StatusFilterDropdownProps) {
  const allStatuses = ['open', 'inProgress', 'resolved', 'skipped'];
  const activeCount = selectedStatuses.size;
  const isFiltered = activeCount < allStatuses.length;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 gap-2 text-xs"
          data-testid="status-filter-dropdown"
        >
          <Filter className="h-3 w-3" />
          <span>Status</span>
          {isFiltered && (
            <span className="ml-1 rounded-full bg-primary px-1.5 py-0.5 text-[10px] font-medium text-primary-foreground">
              {activeCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel className="text-xs">Filter by status</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {allStatuses.map((status) => (
          <DropdownMenuCheckboxItem
            key={status}
            checked={selectedStatuses.has(status)}
            onCheckedChange={() => onStatusToggle(status)}
            className="gap-2"
            data-testid={`status-filter-${status}`}
          >
            <div
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: STATUS_COLORS[status as keyof typeof STATUS_COLORS] }}
            />
            <span className="text-xs">{STATUS_LABELS[status as keyof typeof STATUS_LABELS]}</span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
